<template>
    <div id="app">
        <Header></Header>
        <main class="adjuster">
            <div class="card">
                <div class="title">{{ title }}</div>
                <a-divider class="divider"></a-divider>
                <div class="renderText" v-html="content"></div>
            </div>
            <div class="card">
                <div class="task-title">作业 ({{ taskStat.passed }} / {{ taskStat.total }})</div>
                <div class="task-item" v-for="task of tasks" :key="task.id">
                    <a :href="`/codelab/task?id=${ task.id }`" target="_blank">{{ task.title }}</a>
                    <a-tag v-if="task.passed" color="green">已通过</a-tag>
                </div>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '@/components/Footer';
import { getSSRdata } from '../../../utils/utils';
import { renderMakrdown } from '../utils';

export default {
    data: () => ({
        title: "",
        content: "",
        tasks: [],
    }),
    computed: {
        taskStat() {
            const passed = this.tasks.filter((e) => e.passed).length;
            const total = this.tasks.length;
            return { passed, total };
        }
    },
    created() {
        const { title, content, tasks } = getSSRdata("lesson");
        this.title = title;
        this.content = renderMakrdown(content);
        this.tasks = tasks;

        document.title = title + ' - H5CodeLab';
    },
    methods: {

    },
    components: {
        Header, Footer,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.title {
    text-align: left;
    font-size: 32px;
    font-weight: bold;
    padding: 5px 10px 0;
}
.divider {
    margin: 5px;
}
.renderText {
    padding: 5px;
    text-align: left;
}
.task-title {
    text-align: left;
    font-size: 20px;
    padding: 5px 10px 0;
}
.task-item {
    text-align: left;
    margin-left: 15px;
}
</style>